module.exports = __webpack_public_path__ + "img/notifications_active_outlined.99522300.svg";